module.exports = __webpack_public_path__ + "static/media/delete-primary.a7a3c2fb.svg";